var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSizeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6673 10.8331C16.6673 14.9997 13.7507 17.0831 10.284 18.2914C10.1025 18.3529 9.90527 18.35 9.72565 18.2831C6.25065 17.0831 3.33398 14.9997 3.33398 10.8331V4.99972C3.33398 4.77871 3.42178 4.56675 3.57806 4.41047C3.73434 4.25419 3.9463 4.16639 4.16732 4.16639C5.83398 4.16639 7.91732 3.16639 9.36732 1.89972C9.54386 1.74889 9.76845 1.66602 10.0007 1.66602C10.2329 1.66602 10.4574 1.74889 10.634 1.89972C12.0923 3.17472 14.1673 4.16639 15.834 4.16639C16.055 4.16639 16.267 4.25419 16.4232 4.41047C16.5795 4.56675 16.6673 4.77871 16.6673 4.99972V10.8331Z",
    stroke: "black",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.66602V9.99935",
    stroke: "black",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.334H10.0083",
    stroke: "black",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSizeIcon);
export default __webpack_public_path__ + "static/media/size-icon.e692028eba277953437480fd50b4455b.svg";
export { ForwardRef as ReactComponent };